// extracted by mini-css-extract-plugin
module.exports = {"background_light_1":"#fff","background_light_2":"#fafdfa","background_dark_1":"#f9f9f9"};